import styled from 'styled-components';

export const Plan = styled('span')`
  text-transform: capitalize;
  font-weight: bold;
`;

export const CallToAction = styled('a')`
  text-transform: capitalize;
`;
